var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ljzx-btn",on:{"click":_vm.gotowx}},[_vm._v(" 咨询老师 ")])}
var staticRenderFns = []

export { render, staticRenderFns }